// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.harvest_cleaning_position_enum */
var HarvestCleaningPositionEnum;
(function (HarvestCleaningPositionEnum) {
    HarvestCleaningPositionEnum["PRE"] = "PRE";
    HarvestCleaningPositionEnum["POST"] = "POST";
})(HarvestCleaningPositionEnum || (HarvestCleaningPositionEnum = {}));
;
export default HarvestCleaningPositionEnum;
/** Zod schema for harvest_cleaning_position_enum */
export const harvestCleaningPositionEnum = z.nativeEnum(HarvestCleaningPositionEnum);
//# sourceMappingURL=HarvestCleaningPositionEnum.js.map